// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2Wlos","row":"ProcedureTreatmentSummary_row___rVnP"};